var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASElEQVR42mMY5uD///9nQJhszVs2bwZjEJsszT3d3SAMN4QczRiGkKUZ0xDKDUijqQH4MGEDCGCEAXhAGmFMuQsYKHYB1fILAH6sBiyc5IcIAAAAAElFTkSuQmCC";
  export default img;